import { createContext } from 'react'

import { DeviceInfo } from '../../hooks/useDeviceInfo'

export interface DeviceInfoContextState {
  deviceInfo: DeviceInfo
}

const DeviceInfoContext = createContext<DeviceInfoContextState>({
  deviceInfo: {
    deviceType: 'DESKTOP',
  },
})

DeviceInfoContext.displayName = 'Device Info Context'

export default DeviceInfoContext
